import { render } from "./Authors.vue?vue&type=template&id=036ef05a&scoped=true"
import script from "./Authors.vue?vue&type=script&lang=js"
export * from "./Authors.vue?vue&type=script&lang=js"

import "./Authors.vue?vue&type=style&index=0&id=036ef05a&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-036ef05a"]])

export default __exports__